import { Link } from "react-router-dom";
import { Flame, Truck, ShieldCheck } from "lucide-react";

export const COLLECTIONS_NAV = [
  { slug: "myson-trvs", name: "Thermostatic Radiator Valves" },
  { slug: "myson-manual-radiator-valves", name: "Manual Radiator Valves" },
  { slug: "myson-thermostats", name: "Electronic Controls" },
  { slug: "myson-mpe-valves", name: "Motorised Valves" },
  { slug: "kickspace-grills", name: "Myson Fan Convectors" },
];

export function Logo({ light = false }) {
  return (
    <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5 group">
      <span className={`grid place-items-center w-9 h-9 rounded-sm ${light ? "bg-white text-primary" : "bg-primary text-white"} transition-transform group-hover:-translate-y-0.5`}>
        <Flame className="w-5 h-5" strokeWidth={2.4} />
      </span>
      <span className={`flex flex-col leading-none ${light ? "text-white" : "text-foreground"}`}>
        <span className="font-display font-black text-lg tracking-tight">
          HYDRONIC<span className="text-accent">.</span>
        </span>
        <span className={`text-[9px] tracking-[0.18em] font-semibold ${light ? "text-white/60" : "text-muted-foreground"}`}>
          HEATING CONTROLS &amp; VALVES
        </span>
      </span>
    </Link>
  );
}

export { Truck, ShieldCheck };
